import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { allowRouting } from "@app/features/excel-addin/office-host";
import { UnderUiModule } from "@app/under-ui.module";

allowRouting();

platformBrowserDynamic()
  .bootstrapModule(UnderUiModule, { ngZoneEventCoalescing: true })
  .catch((error) => console.error(error))
